import doRequest from './index';
import { baseUrl, googleMapKey } from '../common/Constant';

const UserService = {
  // a function to call login api
  login: (email, password) => {
    const body = `email=${encodeURIComponent(email)}&password=${encodeURIComponent(
      password
    )}`;
    return doRequest('post', `${baseUrl}logindealer.php`, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
  },
  tempLogin: (tempToken) => {
    return doRequest(
      'post',
      `${baseUrl}login.php?temptoken=${tempToken}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  createUserByRole: (
    email,
    password,
    name,
    addr1,
    addr2,
    city,
    zip,
    country,
    lat,
    lng,
    authLevel,
    compName,
    crv
  ) => {
    return doRequest(
      'post',
      `${baseUrl}createdealer.php?email=${email}&password=${encodeURIComponent(
        password
      )}&name=${encodeURIComponent(name)}&adr1=${encodeURIComponent(
        addr1
      )}&adr2=${encodeURIComponent(addr2)}&city=${encodeURIComponent(
        city
      )}&zip=${zip}&country=${country}&lat=${lat}&lng=${lng}&authlevel=${authLevel}&companyname=${encodeURIComponent(
        compName
      )}&cvr=${crv}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  createUserByAdmin: (
    token,
    email,
    password,
    name,
    addr1,
    addr2,
    city,
    zip,
    country,
    lat,
    lng,
    authLevel,
    compName,
    crv,
    invoiceemail
  ) => {
    return doRequest(
      'post',
      `${baseUrl}createdealer.php?token=${token}&email=${email}&password=${encodeURIComponent(
        password
      )}&name=${encodeURIComponent(name)}&adr1=${encodeURIComponent(
        addr1
      )}&adr2=${encodeURIComponent(addr2)}&city=${encodeURIComponent(
        city
      )}&zip=${zip}&country=${country}&lat=${lat}&lng=${lng}&authlevel=${authLevel}&companyname=${encodeURIComponent(
        compName
      )}&cvr=${encodeURIComponent(crv)}&invoiceemail=${encodeURIComponent(
        invoiceemail || ''
      )}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  googleApiForLatLng: (loc) => {
    return doRequest(
      'get',
      `https://maps.googleapis.com/maps/api/geocode/json?key=${googleMapKey}&address=${encodeURIComponent(
        loc
      )}`
    );
  },
  addBoxWithAddress: (
    token,
    hId,
    hPass,
    sId,
    sPass,
    addr1,
    addr2,
    city,
    zip,
    country,
    lat,
    lng,
    email,
    sms,
    prefix,
    sewerType,
    eqType,
    serviceEmail,
    daystill,
    internalcomment,
    operationEmail
  ) => {
    return doRequest(
      'post',
      `${baseUrl}createbox.php?token=${token}&box1id=${hId}&box1pass=${hPass}&box2id=${sId}&box2pass=${sPass}&adr1=${encodeURIComponent(
        addr1
      )}&adr2=${encodeURIComponent(
        addr2
      )}&city=${city}&zip=${zip}&country=${country}&lat=${lat}&lng=${lng}&alarmemail=${email}&alarmsms=${sms}&alarmprefix=${prefix}&sewertype=${sewerType}&uwsequipment=${eqType}&serviceemail=${serviceEmail}&daystillservice=${daystill}&internalcomment=${encodeURIComponent(
        internalcomment || ''
      )}&operationemail=${operationEmail}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  addBoxWithoutAddress: (
    token,
    hId,
    hPass,
    sId,
    sPass,
    email,
    sms,
    prefix,
    sewerType,
    eqType,
    serviceEmail,
    daystill,
    internalcomment,
    operationEmail
  ) => {
    return doRequest(
      'post',
      `${baseUrl}createbox.php?token=${token}&box1id=${hId}&box1pass=${hPass}&box2id=${sId}&box2pass=${sPass}&alarmemail=${email}&alarmsms=${sms}&alarmprefix=${prefix}&sewertype=${sewerType}&uwsequipment=${eqType}&serviceemail=${serviceEmail}&daystillservice=${daystill}&internalcomment=${encodeURIComponent(
        internalcomment || ''
      )}&operationemail=${operationEmail}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  changeUserInfo: (token, paramsString) => {
    return doRequest(
      'post',
      `${baseUrl}editdealer.php?token=${token}&${paramsString}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  changeBoxSettings: (token, paramsString) => {
    return doRequest(
      'post',
      `${baseUrl}editbox.php?token=${token}&${paramsString}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  replaceBox: (token, paramsString) => {
    return doRequest(
      'post',
      `${baseUrl}replacebox.php?token=${token}&${paramsString}`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
  },
  forgotPassword: (email) => {
    return doRequest('get', `${baseUrl}forgotpassword.php?email=${email}`);
  },
  dealerLogin: (email, password) => {
    const body = `email=${encodeURIComponent(email)}&password=${encodeURIComponent(
      password
    )}`;
    return doRequest('post', `${baseUrl}logindealer.php`, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
  },
};

export default UserService;
